// Chat bubbles show plain text. Assistant replies saved before 9 Oct (and any
// that slip through) can carry markdown marks (**bold**, *italic*, ## ...),
// which showed as stray symbols. Same rules as the server-side cleaner in
// supabase/functions/_shared/supportModelPayload.ts; a test keeps them equal.
export function toPlainText(text: string): string {
  return text
    .replace(/\[([^\]]+)\]\((?:[^)]+)\)/g, "$1")
    .replace(/(\*\*|__)(.+?)\1/g, "$2")
    .replace(/~~(.+?)~~/g, "$1")
    .replace(/(^|[\s(])[*_](\S[^*_\n]*?)[*_](?=[\s).,!?:;]|$)/g, "$1$2")
    .replace(/`([^`]+)`/g, "$1")
    .replace(/^[ \t]{0,3}#{1,6}[ \t]+/gm, "")
    .replace(/^[ \t]*[*•][ \t]+/gm, "- ")
    .replace(/[*~`]{1,3}/g, "")
    .replace(/\n{3,}/g, "\n\n")
    .trim();
}
